var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 70,
    viewBox: "0 0 31 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1295 35.1771C11.8304 46.6466 19.3228 55.7283 28.88 55.7787L28.5358 68.9809C12.7214 69.0756 0.418342 54.1277 0.905504 35.4451C1.39267 16.7624 14.4908 1.21951 30.3196 0.572928L29.9756 13.7652C20.404 14.2636 12.4286 23.7077 12.1295 35.1771Z",
    stroke: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerVector);
export default __webpack_public_path__ + "static/media/banner-vector.48f613d4c093d42ec229483b08a5828f.svg";
export { ForwardRef as ReactComponent };